import React from 'react'
import axios from 'axios'
import Questions from '../../containers/Questions/Questions';
import Results from '../../containers/Results/Results';
import './Quiz.css'

class Quiz extends React.Component{
        state= {
            data: [],
            index: 0,
            score: [],
            numberOfPlayers: Number(this.props.players),
            counter: 0
        }

    componentDidMount = () => {
        this.createScoreArray()
        this.apiCall();
    }

    createScoreArray = () => {
        this.setState({score: Array(this.state.numberOfPlayers).fill(0)})
    }

    apiCall = () => {
        axios.get(`https://opentdb.com/api.php?amount=${this.props.maxNumberOfQuestions}&category=${this.props.catID}&difficulty=${this.props.diff}`)
        .then(response => {
            this.setState({data: response.data.results})})
    }

    nextGameState = answer =>{
        let newScore = this.calculateScore(answer);
        let nextQuestion = this.updateQuestion();
        this.setState({score : newScore, counter: this.state.counter + 1, index: this.state.index + nextQuestion});
    }

    calculateScore = answer =>{
        let points = this.state.score;
        let currentPlayer = this.state.counter % this.state.numberOfPlayers;
        if(answer === this.state.data[this.state.index].correct_answer){
            points[currentPlayer] += 1;
        } else{
            points[currentPlayer] += 0;
        }
        return points;
    };

    updateQuestion = () =>{
        let questionIncrement;
        if(this.state.numberOfPlayers === 1) {
            questionIncrement = 1;
        } else {
            questionIncrement = this.state.counter % this.state.numberOfPlayers
        }
        return questionIncrement;
    }

    gameState = () => {
        if(this.state.index === this.props.maxNumberOfQuestions) {
            return (<Results 
                    maxScore = {this.props.maxNumberOfQuestions}
                    score = {this.state.score}
                    />);
        }
        else if(this.state.data.length !== 0) { 
            return this.generateNextQuestion();
        }
        else {
            return <p>LOADING</p>;
       }
    }

    generateNextQuestion = () => {
     const player = this.state.counter % this.state.numberOfPlayers + 1;
     const gameInfo = this.state.data[this.state.index];
     const nextGameState = this.nextGameState;
     const score = this.state.score[this.state.counter % this.state.numberOfPlayers];
     const maxScore = this.props.maxNumberOfQuestions;
     const colors = ['#63B766','#B36B36'];
     const color = colors[this.state.counter % this.state.numberOfPlayers]
        return( < Questions 
                 player={player}
                 gameInfo={gameInfo}
                 nextGameState={nextGameState}
                 score={score}
                 maxScore={maxScore}
                 color={color}
                 />
           ) 
    }

    render() {
        return (
            <div>
                {this.gameState()}
            </div>
        )
    }
}

export default Quiz;